<div class="form-group" ngModelGroup="formField{{ formField.id }}">
    <sb-form-field-label [formField]="formField"></sb-form-field-label>

    <ng-select
        id="form-element-{{ formField.id }}"
        name="formField{{ formField.id }}"
        bindLabel="communityName"
        bindValue="communityName"
        dropdownPosition="bottom"
        class="select-control"
        appSelectAccessibility
        [inputAriaLabelAttribute]="formField.label || formField.placeholder"
        [appendTo]="'body'"
        notFoundText="{{ 'No inbox found' | translate }}"
        placeholder="{{ 'Choose inbox *' | translate }}"
        [items]="outlookUserService.communities"
        [required]="true"
        (change)="onSelectCommunity($event)"
        [(ngModel)]="formField.value">
    </ng-select>
</div>
